import { analytics, EventProperties } from './posthogClient';

export const trackEvent = (
    event: string,
    properties?: EventProperties,
): void => {
    analytics.capture(event, properties);
};

export const trackIdentify = (
    distinctId: string,
    properties?: EventProperties,
): void => {
    analytics.identify(distinctId, properties);
};

export const trackGroup = (
    groupType: string,
    groupKey: string,
    properties?: EventProperties,
): void => {
    analytics.group(groupType, groupKey, properties);
};

export const trackReset = (): void => {
    analytics.reset();
};
